import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { STOCK, DROPDOWNS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(STOCK.BASE);

// Export service with additional custom methods
export const StockService = {
  ...baseCRUD,

  // Override getAll to handle status uppercase conversion
  getAll: async ({ page = 1, limit = 100, status, search } = {}) => {
    const params = { page, limit };
    if (status) params.status = status.toUpperCase();
    if (search) params.search = search;
    console.log('Fetching stocks with params:', await baseCRUD.getAll(params));
    return baseCRUD.getAll(params);
  },

  // Get dropdown data
  getAgeGroups: () => fetchDropdowns(DROPDOWNS.BASE),
};

export default StockService;
